import React, { useState, useEffect } from "react";
import "../../../css/CRUDModal.css";
import { apiList } from "../../../helpers/apiList";
import CustomAlert from "../../../helpers/CustomAlert";
import { axiosPostApi } from "../../../helpers/interceptorServices";
import AddVectorIcon from "../../../assets/Icons/Add Vector.png";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";
import BusinessIcon from "@mui/icons-material/Business";
import PhoneIcon from "@mui/icons-material/Phone";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";

const GenerateStickerModal = ({
  show,
  handleClose,
  callApi,
  editData,
  action,
  columnData,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [formData, setFormData] = useState({
    quantity: "",
  });

  const [errors, setErrors] = useState({
    quantity: "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (action === "add") {
      setFormData({
        quantity: "",
      });
    } else if (
      action === "modify" ||
      action === "view" ||
      action === "delete" ||
      action === "auth" ||
      action === "check"
    ) {
      setFormData({
        quantity: editData?.quantity || "",
      });
    }

    setErrors({
      quantity: "",
    });
  }, [show]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    let updatedValue = value;
    if (id === "quantity") updatedValue = value.toUpperCase();

    setFormData((prev) => ({
      ...prev,
      [id]: updatedValue,
    }));

    // Clear error for the field while user edits
    setErrors((prev) => {
      if (!prev || !prev[id]) return prev;
      const next = { ...prev };
      delete next[id];
      return next;
    });
  };

  const validate = () => {
    const newErrors = {};
    const { quantity } = formData;

    // Quantity validations
    if (!quantity.trim()) {
      newErrors.quantity = "Quantity is required.";
    } else if (!/^[0-9]+$/.test(quantity.trim())) {
      newErrors.quantity = "Quantity can only contain numbers";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;
    const trimmedValue = value?.toString().trim();

    let fieldError = "";

    switch (id) {
      case "quantity":
        if (!trimmedValue) {
          fieldError = "Quantity is required";
        } else if (!/^[0-9]+$/.test(trimmedValue)) {
          fieldError = "Quantity can only contain numbers";
        }
        break;

      default:
        break;
    }

    setErrors((prev) => {
      const next = { ...prev };
      if (fieldError) {
        next[id] = fieldError;
      } else {
        // remove previous error for this field when it's valid
        delete next[id];
      }
      return next;
    });
  };

  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  //   const isEditMode = action === "modify";
  const isAuthMode = action === "auth";
  const isCheckMode = action === "check";

  const isReadOnly = isViewMode || isDeleteMode || isAuthMode || isCheckMode;

  const handleBack = () => {
    handleClose();
    setErrors({});
  };

  const handleGenerateSticker = async () => {
    const isValid = validate();

    if (isValid) {
      let apiUrl = "";
      if (action === "add") {
        apiUrl = apiList.BARCODE_REQUEST;
      } else if (action === "modify") {
        apiUrl = apiList.MODIFY_COURIER_MASTER;
      }

      setLoading(true);
      try {
        const payload = {
          username: loggedInUserName,
          quantity: Number(formData.quantity),
        };

        const response = await axiosPostApi(apiUrl, payload);
        if (
          response?.data?.status === true &&
          response?.data?.respCode === "00"
        ) {
          setLoading(false);
          CustomAlert({
            title: response?.data?.message,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
            allowOutsideClick: false,
          });
          callApi(1);
          handleClose();
        } else if (response?.status === 200 && !response?.data?.status) {
          CustomAlert({
            title: "Failed to Request",
            text: response.data.message,
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      } catch (error) {
        console.error("Error processing request:", error);
        CustomAlert({
          title: "Error",
          text: "An error occurred. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1031,
          }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content w-[500px] min-h-fit h-[241px] rounded-3xl p-6 bg-white border border-gray-200">
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div className="modal-header flex items-center justify-between border-b-0 mb-3">
                <div className="flex items-center">
                  <img
                    src={AddVectorIcon}
                    alt="Add Icon"
                    className="w-[43px] h-[38px] mr-2"
                  />
                  <h5 className="modal-title main-title font-medium text-lg">
                    Generate Sticker
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleBack}
                />
              </div>
              <form>
                <div className="modal-body space-y-4 items-center">
                  <div className="grid grid-cols-1 gap-4">
                    {/* Quantity */}
                    <div className="form-group">
                      <label htmlFor="quantity">
                        Quantity<span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <ProductionQuantityLimitsIcon
                            className="text-gray"
                            sx={{ width: 20, height: 20 }}
                          />
                        </span>

                        <input
                          type="text"
                          className="text-right placeholder:text-left pl-10 pr-4 py-2 h-[38px] border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          placeholder="Enter Quantity"
                          id="quantity"
                          value={formData.quantity}
                          disabled={isReadOnly}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        />
                      </div>
                      {!isReadOnly && errors.quantity && (
                        <span className="error text-red-500 text-sm">
                          {errors.quantity}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex justify-center gap-4 pt-4 border-t-0">
                  <button
                    type="button"
                    className="btn btn-back w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                    onClick={handleBack}
                  >
                    Back
                  </button>
                  {!isReadOnly && (action === "add" || action === "modify") && (
                    <button
                      type="button"
                      className="btn btn-submit w-[133px] h-[33px] !rounded-[8px] flex items-center justify-center"
                      onClick={handleGenerateSticker}
                      disabled={loading}
                    >
                      Submit
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GenerateStickerModal;
